import { IIconProps } from 'src/interfaces/IconProps';

const CheckIcon = ({ width = 15, height = 20, color = '#fff', ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 16 11' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      // eslint-disable-next-line max-len
      d='M15.8621 0.155173C16.0525 0.355139 16.0448 0.671627 15.8448 0.86207L5.34483 10.8621C5.15652 11.0414 4.86218 11.0465 4.66782 10.8737L0.167823 6.87371C-0.038568 6.69025 -0.0571583 6.37421 0.126301 6.16782C0.30976 5.96143 0.625796 5.94284 0.832187 6.1263L4.98833 9.82064L15.1552 0.137932C15.3551 -0.0525111 15.6716 -0.0447918 15.8621 0.155173Z'
      fill={color}
    />
  </svg>
);

export default CheckIcon;
